// src/store/reducers/pageLoader.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pageLoader: false,
  hidePageLoader: false,
  showPageLoader: true,
};

const pageLoaderSlice = createSlice({
  name: "pageLoader",
  initialState,
  reducers: {
    showLoader: (state) => {
      state.pageLoader = true;
      state.hidePageLoader = false;
      state.showPageLoader = true;
    },
    hideLoader: (state) => {
      state.pageLoader = false;
      state.hidePageLoader = true;
      state.showPageLoader = false;
    },
    toggleLoader: (state) => {
      state.pageLoader = !state.pageLoader;
      state.hidePageLoader = !state.hidePageLoader;
      state.showPageLoader = !state.showPageLoader;
    },
    setLoaderState: (state, action) => {
      const { pageLoader, hidePageLoader, showPageLoader } = action.payload || {};
      if (typeof pageLoader === "boolean") state.pageLoader = pageLoader;
      if (typeof hidePageLoader === "boolean") state.hidePageLoader = hidePageLoader;
      if (typeof showPageLoader === "boolean") state.showPageLoader = showPageLoader;
    },
    resetLoader: (state) => {
      state.pageLoader = true;
      state.hidePageLoader = false;
      state.showPageLoader = true;
    },
  },
});

export const {
  showLoader,
  hideLoader,
  toggleLoader,
  setLoaderState,
  resetLoader,
} = pageLoaderSlice.actions;

export default pageLoaderSlice.reducer;
